import { h, defineComponent } from 'vue';
import { container } from '@/ui/components';
import PlanDetails from '@/_legacy/views/Subscriptions/PlanDetails.vue';

export const PlanDetailsPage = defineComponent({
  name: 'PlanDetailsPage',
  setup() {
    return function render() {
      return container(
        [
          container([
            // @ts-ignore
            h(PlanDetails, { class: 'legacy' }),
          ], 'medium'),
        ],
      );
    };
  },
});
